import ReleaseNotes from '@/pages/releaseNotes/ReleaseNotes.page'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/release-notes')({
  component: () => <ReleaseNotesLayout />,
})

const ReleaseNotesLayout = () => {
  return (
    <>
      <ReleaseNotes />
    </>
  )
}
